import React from "react";

export function CalendarSvg(props: {color: string}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      x='0'
      y='15'
      fontFamily='Arial, Helvetica, sans-serif'
      fontWeight='700'
      preserveAspectRatio='xMidYMin slice'
      viewBox='0 0 1000 1000'
      style={{ width: "100%", maxWidth: "100%", height: "100%" }}
    >
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='614.3958435058594 169.78717422485352'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M697.835 127.926a421.4 421.4 0 00-183.128-49.07l1.745-49.969A471.4 471.4 0 01721.309 83.78z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_0'
            fill='#e1e1e1'
            d='M515.23 63.866a436.4 436.4 0 01189.647 50.816'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_0' startOffset='50%' textAnchor='middle'>
              JANUAR
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M600.66 310.687a214.41 214.41 0 00-93.177-24.966l7.224-206.864a421.4 421.4 0 01183.128 49.069z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='756.6950073242188 243.30506134033203'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M857.367 276.692a421.4 421.4 0 00-134.059-134.06l26.496-42.402A471.4 471.4 0 01899.77 250.196z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_1'
            fill='#e1e1e1'
            d='M731.257 129.912a436.4 436.4 0 01138.831 138.831'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_1' startOffset='50%' textAnchor='middle'>
              FEBRUAR
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M681.83 386.38a214.41 214.41 0 00-68.21-68.21l109.688-175.537a421.4 421.4 0 01134.06 134.059z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='830.2129211425781 385.6041564941406'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M921.143 485.293a421.4 421.4 0 00-49.069-183.128l44.147-23.474a471.4 471.4 0 0154.892 204.857z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_2'
            fill='#e1e1e1'
            d='M885.318 295.123a436.4 436.4 0 0150.816 189.647'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_2' startOffset='50%' textAnchor='middle'>
              MARS
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M714.28 492.517a214.41 214.41 0 00-24.967-93.176l182.761-97.176a421.4 421.4 0 0149.07 183.128z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='830.2128295898438 614.3958740234375'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M872.074 697.835a421.4 421.4 0 0049.07-183.128l49.969 1.745a471.4 471.4 0 01-54.892 204.857z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_3'
            fill='#e1e1e1'
            d='M936.134 515.23a436.4 436.4 0 01-50.816 189.647'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_3' startOffset='50%' textAnchor='middle'>
              APRIL
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M689.313 600.66a214.41 214.41 0 0024.966-93.177l206.864 7.224a421.4 421.4 0 01-49.069 183.128z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='756.6949462890625 756.6949462890625'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M723.308 857.367a421.4 421.4 0 00134.06-134.059l42.402 26.496A471.4 471.4 0 01749.804 899.77z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_4'
            fill='#e1e1e1'
            d='M870.088 731.257a436.4 436.4 0 01-138.831 138.831'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_4' startOffset='50%' textAnchor='middle'>
              MAI
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M613.62 681.83a214.41 214.41 0 0068.21-68.21l175.537 109.688a421.4 421.4 0 01-134.059 134.06z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='614.3958435058594 830.2129211425781'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M514.707 921.143a421.4 421.4 0 00183.128-49.069l23.474 44.147a471.4 471.4 0 01-204.857 54.892z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_5'
            fill='#e1e1e1'
            d='M704.877 885.318a436.4 436.4 0 01-189.647 50.816'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_5' startOffset='50%' textAnchor='middle'>
              JUNI
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M507.483 714.28a214.41 214.41 0 0093.176-24.967l97.176 182.761a421.4 421.4 0 01-183.128 49.07z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='385.60414123535156 830.2128295898438'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M302.165 872.074a421.4 421.4 0 00183.128 49.07l-1.745 49.969a471.4 471.4 0 01-204.857-54.892z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_6'
            fill='#e1e1e1'
            d='M484.77 936.134a436.4 436.4 0 01-189.647-50.816'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_6' startOffset='50%' textAnchor='middle'>
              JULI
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M399.34 689.313a214.41 214.41 0 0093.177 24.966l-7.224 206.864a421.4 421.4 0 01-183.128-49.069z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='243.30503845214844 756.6949462890625'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M142.633 723.308a421.4 421.4 0 00134.059 134.06l-26.496 42.402A471.4 471.4 0 01100.23 749.804z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_7'
            fill='#e1e1e1'
            d='M268.743 870.088a436.4 436.4 0 01-138.831-138.831'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_7' startOffset='50%' textAnchor='middle'>
              AUGUST
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M318.17 613.62a214.41 214.41 0 0068.21 68.21L276.692 857.367a421.4 421.4 0 01-134.06-134.059z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='169.78718185424805 614.3958435058594'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M78.857 514.707a421.4 421.4 0 0049.069 183.128L83.779 721.31a471.4 471.4 0 01-54.892-204.857z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_8'
            fill='#e1e1e1'
            d='M114.682 704.877A436.4 436.4 0 0163.866 515.23'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_8' startOffset='50%' textAnchor='middle'>
              SEPTEMBER
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M285.72 507.483a214.41 214.41 0 0024.967 93.176l-182.761 97.176a421.4 421.4 0 01-49.07-183.128z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='169.78717422485352 385.60414123535156'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M127.926 302.165a421.4 421.4 0 00-49.07 183.128l-49.969-1.745A471.4 471.4 0 0183.78 278.691z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_9'
            fill='#e1e1e1'
            d='M63.866 484.77a436.4 436.4 0 0150.816-189.647'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath href='#text_path_9' startOffset='50%' textAnchor='middle'>
              OKTOBER
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M310.687 399.34a214.41 214.41 0 00-24.966 93.177l-206.864-7.224a421.4 421.4 0 0149.069-183.128z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='243.30506134033203 243.30503845214844'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M276.692 142.633a421.4 421.4 0 00-134.06 134.059l-42.402-26.496A471.4 471.4 0 01250.196 100.23z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_10'
            fill='#e1e1e1'
            d='M129.912 268.743a436.4 436.4 0 01138.831-138.831'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath
              href='#text_path_10'
              startOffset='50%'
              textAnchor='middle'
            >
              NOVEMBER
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M386.38 318.17a214.41 214.41 0 00-68.21 68.21L142.633 276.692a421.4 421.4 0 01134.059-134.06z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <g
        className='sc-cCbXAZ gmGTOg monthPie'
        data-svg-origin='385.6041564941406 169.78718185424805'
        style={{
          WebkitTransformOrigin: "0 0 0",
          msTransformOrigin: "0 0 0",
          transformOrigin: "0 0 0",
        }}
        opacity='1'
      >
        <g>
          <path
            fill='#e1e1e1'
            d='M485.293 78.857a421.4 421.4 0 00-183.128 49.069L278.69 83.779a471.4 471.4 0 01204.857-54.892z'
            className='sc-ivVeuv drAkPu'
          ></path>
          <path
            id='text_path_11'
            fill='#e1e1e1'
            d='M295.123 114.682A436.4 436.4 0 01484.77 63.866'
          ></path>
          <text className='sc-dTLGrV dEeWXk'>
            <textPath
              href='#text_path_11'
              startOffset='50%'
              textAnchor='middle'
            >
              DESEMBER
            </textPath>
          </text>
        </g>
        <path
          fill={props.color}
          fillOpacity='1'
          d='M492.517 285.72a214.41 214.41 0 00-93.176 24.967l-97.176-182.761a421.4 421.4 0 01183.128-49.07z'
          className='sc-fHSTwm cGRsas'
        ></path>
      </g>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        x='0'
        y='0'
        version='1.1'
        viewBox='-350 0 1200 200'
        xmlSpace='preserve'
      >
        <path fill='#983925' d='M175.8 79.1l-27-47.4L120.1 54z'></path>
        <path fill='#ff5c3e' d='M70.1 31.5L19.6 132.2 120.1 54z'></path>
        <path fill='#c05325' d='M148.8 31.7l-35.2-.1-43.5-.1 50 22.5z'></path>
        <path
          d='M156.5 144.2h-4.8c-.7 0-1.1-.5-1.1-1.1v-27.6c0-4.8-1.9-6.5-6.8-6.5-6.4 0-13 1.9-13 1.9v32.3c0 .7-.4 1.1-1.1 1.1H125c-.8 0-1.2-.5-1.2-1.1v-27.6c0-4.8-1.8-6.5-6.7-6.5-6.4 0-13.1 1.9-13.1 1.9v32.3c0 .7-.4 1.1-1.1 1.1h-4.7c-.8 0-1.2-.5-1.2-1.1v-31.7c0-2.9.5-4.2 4.4-5.5 3.9-1.3 11.2-2.3 16.1-2.3 4.7 0 8.1 1 10.1 2.8 3.8-1.4 11.7-2.8 16.7-2.8 9.1 0 13.4 2.7 13.4 11v28.5c0 .5-.5.9-1.2.9zm35.3 1c-13.1 0-16.9-5.3-16.9-15.4v-24c0-.7.5-1 1.1-1.1l4.9-1.1h.2c.6 0 .8.5.8 1.1v25.8c0 6.6 2.3 9.5 9.9 9.5 9 0 9.9-4.4 9.9-9.7l-.1-24.4c0-.8.4-1.1 1.1-1.1l4.8-1.1h.3c.6 0 .8.5.8 1.1v25.1c.1 7.7-1.7 15.3-16.8 15.3zm67.1-1h-4.7c-.8 0-1.2-.5-1.2-1.1v-27.6c0-4.8-1.8-6.5-6.7-6.5-6.4 0-13 1.9-13 1.9v32.3c0 .7-.4 1.1-1.1 1.1h-4.7c-.8 0-1.2-.5-1.2-1.1v-31.7c0-2.9.5-4.2 4.4-5.5 3.9-1.3 11.2-2.3 16-2.3 9.1 0 13.4 2.7 13.4 11v28.5c-.1.6-.4 1-1.2 1zm25.6-46H280c-.8 0-1.3-.5-1.3-1.3v-8.2c0-.8.5-1.3 1.3-1.3h4.5c.8 0 1.2.5 1.2 1.3v8.2c0 .8-.4 1.3-1.2 1.3zm.2 46h-4.8c-.7 0-1.1-.5-1.1-1.1v-37.2c0-.7.5-1.1 1.1-1.1h4.8c.7 0 1.1.5 1.1 1.1v37.2c0 .7-.5 1.1-1.1 1.1zm53.5-.7c0 .4-.3.7-.8.7h-7.2c-.3 0-.5-.2-.8-.4L314.8 127h-2.9v16.1c0 .7-.4 1.1-1.1 1.1H306c-.8 0-1.2-.5-1.2-1.1V89.6c0-.7.4-1 1.1-1.1l4.9-1.1h.2c.6 0 .8.5.8 1.1v33.4h2.9l14.4-16.9c.2-.2.5-.4.7-.4l6.4.2c.5 0 .8.4.8.7 0 .2-.1.3-.2.4l-16 18.2 17.1 19.2c.3-.1.3.1.3.2zm29.8 1.7c-13.1 0-16.9-5.3-16.9-15.4v-24c0-.7.5-1 1.1-1.1l4.9-1.1h.2c.6 0 .8.5.8 1.1v25.8c0 6.6 2.3 9.5 9.9 9.5 9 0 9.9-4.4 9.9-9.7l-.1-24.4c0-.8.4-1.1 1.1-1.1l4.8-1.1h.3c.6 0 .8.5.8 1.1v25.1c0 7.7-1.8 15.3-16.8 15.3zm94-1h-4.8c-.7 0-1.1-.5-1.1-1.1v-27.6c0-4.8-1.9-6.5-6.8-6.5-6.4 0-13 1.9-13 1.9v32.3c0 .7-.4 1.1-1.1 1.1h-4.8c-.8 0-1.2-.5-1.2-1.1v-27.6c0-4.8-1.8-6.5-6.7-6.5-6.4 0-13.1 1.9-13.1 1.9v32.3c0 .7-.4 1.1-1.1 1.1h-4.7c-.8 0-1.2-.5-1.2-1.1v-31.7c0-2.9.5-4.2 4.4-5.5 3.9-1.3 11.2-2.3 16.1-2.3 4.7 0 8.1 1 10.1 2.8 3.8-1.4 11.7-2.8 16.7-2.8 9.1 0 13.4 2.7 13.4 11v28.5c0 .5-.5.9-1.1.9z'
          className='st3'
        ></path>
      </svg>
    </svg>
  );
}

